import React from 'react';

// Helper to check if clicks & impressions are valid numbers > 0
const isValidMetric = (clicks, impressions) => {
  return (
    typeof clicks === 'number' &&
    typeof impressions === 'number' &&
    clicks > 0 &&
    impressions > 0
  );
};

// Helper to format CTR
const formatCTR = (ctr) => `${parseFloat(ctr).toFixed(2)}%`;

const ProductSummary = ({ records }) => {
  if (!Array.isArray(records?.title)) return null;

  const titles = records.title;

  const totalImpressions = titles.reduce((sum, t) =>
    typeof t.impressions === 'number' ? sum + t.impressions : sum, 0);

  const totalClicks = titles.reduce((sum, t) =>
    typeof t.clicks === 'number' ? sum + t.clicks : sum, 0);

  const totalDays = titles.reduce((sum, t) =>
    typeof t.days === 'number' ? sum + t.days : sum, 0);

  const totalCPC = titles.reduce((sum, t) =>
    typeof t.cpc === 'number' ? sum + t.cpc : sum, 0);
  const averageCPC = titles.length > 0 ? (totalCPC / titles.length).toFixed(2) : 0;

  // Find best CTR title
   
    
    const selectedTitle = titles.find(t => t.key === records.selected_key);
    //const startTitle = titles[0]; // first permutation

     


  return (
    <div className="flex flex-wrap gap-2 mt-2 text-xs font-medium">
      <span className="px-2 py-0.5 rounded-full bg-green-100 text-gray-800 dark:bg-zinc-700 dark:text-zinc-300">
        Total Impressions: {totalImpressions}
      </span>

      <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 dark:bg-zinc-700 dark:text-zinc-300">
        Total Clicks: {totalClicks}
      </span>
      {records.status === 'completed' && (
        <> 
        
      {selectedTitle && isValidMetric(selectedTitle.clicks, selectedTitle.impressions) && (
        <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
          Selected CTR: {formatCTR(selectedTitle.ctr)} ({selectedTitle.key})
        </span>
      )}

      {(<span className="px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300">
          Best Title: {records.selected_title}
        </span>)}
       

      {(
        <span className="px-2 py-0.5 rounded-full bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300">
          Uplift: {(records.uplift !== 0) ? `${records.uplift}%` : records.uplift}
          
        </span>
      )}
      {averageCPC && (
        <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300">
          Avg CPC: {averageCPC}
        </span>
      )}
      {totalDays && (
        <span className="px-2 py-0.5 rounded-full bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300">
          Total Days: {totalDays}
        </span>
      )}
      </>
    )}
    </div>
  );
};

export default ProductSummary;
